import { InstitutionListItem } from 'src/provider/API/v2/call-service/configuration'

const CSV_COLUMNS: { header: string; get: (row: InstitutionListItem) => unknown }[] = [
    { header: 'institutionId', get: (r) => r.id },
    { header: 'enabled', get: (r) => r.export?.enabled ?? r.isActive },
    { header: 'id', get: (r) => r.id },
    { header: 'institutionCode', get: (r) => r.institutionCode },
    { header: 'name', get: (r) => r.name },
    { header: 'logo', get: (r) => r.logo },
    { header: 'favIcon', get: (r) => r.export?.favIcon },
    { header: 'stamp', get: (r) => r.export?.stamp },
    { header: 'design', get: (r) => r.export?.design },
    { header: 'appName', get: (r) => r.export?.appName },
    { header: 'address', get: (r) => r.export?.address },
    { header: 'website', get: (r) => r.export?.website },
    { header: 'correspondenceEmail', get: (r) => r.export?.correspondenceEmail },
    { header: 'correspondencePhone', get: (r) => r.export?.correspondencePhone },
    { header: 'emailSenderID', get: (r) => r.export?.emailSenderID },
    { header: 'setupDate', get: (r) => r.setupDate },
    { header: 'goLiveDate', get: (r) => r.export?.goLiveDate },
    { header: 'primaryColour', get: (r) => r.export?.primaryColour },
    { header: 'secondaryColour', get: (r) => r.export?.secondaryColour },
    { header: 'primaryColour2', get: (r) => r.export?.primaryColour2 },
    { header: 'secondaryColour2', get: (r) => r.export?.secondaryColour2 },
    { header: 'hasLiveChat', get: (r) => r.export?.hasLiveChat },
    { header: 'usePINforLogin', get: (r) => r.export?.usePINforLogin },
    { header: 'hasTransfer', get: (r) => r.export?.hasTransfer },
    { header: 'useIdemityForAccountLimitChange', get: (r) => r.export?.useIdemityForAccountLimitChange },
    { header: 'accountLimitIdemity', get: (r) => r.export?.accountLimitIdemity },
    { header: 'useVerifyMeForOnboarding', get: (r) => r.export?.useVerifyMeForOnboarding },
    { header: 'useAirtimeAsBills', get: (r) => r.export?.useAirtimeAsBills },
    { header: 'accountNumberLength', get: (r) => r.export?.accountNumberLength },
    { header: 'paymentItemIsHidden', get: (r) => r.export?.paymentItemIsHidden },
    { header: 'shouldLockNewProfile', get: (r) => r.export?.shouldLockNewProfile },
    { header: 'defaultOneTimeTransactionLimit', get: (r) => r.export?.defaultOneTimeTransactionLimit },
    { header: 'defaultDailyTransactionLimit', get: (r) => r.export?.defaultDailyTransactionLimit },
    { header: 'testAccountNumber', get: (r) => r.export?.testAccountNumber },
    { header: 'testAccountCustomerID', get: (r) => r.export?.testAccountCustomerID },
    { header: 'testAccountUsername', get: (r) => r.export?.testAccountUsername },
    { header: 'quickTellerURL', get: (r) => r.export?.quickTellerURL },
    { header: 'institutionType', get: (r) => r.export?.institutionType },
    { header: 'pilotPhaseMaximumUserCount', get: (r) => r.export?.pilotPhaseMaximumUserCount },
    { header: 'implementationPhase', get: (r) => r.export?.implementationPhase },
    { header: 'defaultAccountOpeningProductCode', get: (r) => r.export?.defaultAccountOpeningProductCode },
    { header: 'defaultAccountOfficerCode', get: (r) => r.export?.defaultAccountOfficerCode },
    { header: 'ussdCode', get: (r) => r.export?.ussdCode },
    { header: 'allowedAccountProductCodes', get: (r) => r.export?.allowedAccountProductCodes },
    { header: 'disallowedAccountProductCodes', get: (r) => r.export?.disallowedAccountProductCodes },
    { header: 'disallowedLoanProductCodes', get: (r) => r.export?.disallowedLoanProductCodes },
    { header: 'disallowedFixedDepositProductCodes', get: (r) => r.export?.disallowedFixedDepositProductCodes },
    { header: 'phoneNumberLength', get: (r) => r.export?.phoneNumberLength },
    { header: 'transferGateway', get: (r) => r.export?.transferGateway },
    { header: 'maximumOneTimeTransactionLimit', get: (r) => r.export?.maximumOneTimeTransactionLimit },
    { header: 'maximumDailyTransactionLimit', get: (r) => r.export?.maximumDailyTransactionLimit },
    { header: 'newDeviceSpendingCap', get: (r) => r.export?.newDeviceSpendingCap },
    { header: 'alias', get: (r) => r.alias },
    { header: 'customizedUrl', get: (r) => r.export?.customizedUrl },
    { header: 'twoFactorThresholdAmount', get: (r) => r.export?.twoFactorThresholdAmount },
    { header: 'showTransactions', get: (r) => r.export?.showTransactions },
    { header: 'termsAndConditionsUrl', get: (r) => r.export?.termsAndConditionsUrl },
    { header: 'privacyPolicyUrl', get: (r) => r.export?.privacyPolicyUrl },
    { header: 'loanPolicyUrl', get: (r) => r.export?.loanPolicyUrl },
    { header: 'appzoneUsername', get: (r) => r.export?.appzoneUsername },
    { header: 'appzoneAccountNumber', get: (r) => r.export?.appzoneAccountNumber },
    { header: 'appzoneCustomerId', get: (r) => r.export?.appzoneCustomerId },
    { header: 'hideWithdrawableBalance', get: (r) => r.export?.hideWithdrawableBalance },
    { header: 'hideAvailableBalance', get: (r) => r.export?.hideAvailableBalance },
    { header: 'isBaasInstitution', get: (r) => r.export?.isBaasInstitution },
    { header: 'billsPaymentGateway', get: (r) => r.export?.billsPaymentGateway },
    { header: 'newCustomerOnboardingType', get: (r) => r.export?.newCustomerOnboardingType },
    { header: 'existingCustomerOnboardingType', get: (r) => r.export?.existingCustomerOnboardingType },
    { header: 'hasWeb', get: (r) => r.export?.hasWeb },
    { header: 'hasMobile', get: (r) => r.export?.hasMobile },
    { header: 'hasChangedSinceLastBuild', get: (r) => r.export?.hasChangedSinceLastBuild },
    { header: 'defaultCurrency', get: (r) => r.export?.defaultCurrency },
    { header: 'cardFee', get: (r) => r.export?.cardFee },
    { header: 'extraAccountsProductCodes', get: (r) => r.export?.extraAccountsProductCodes },
    { header: 'extraAccountOfficerCode', get: (r) => r.export?.extraAccountOfficerCode },
    { header: 'usePhoneNumberAsAccountNumber', get: (r) => r.export?.usePhoneNumberAsAccountNumber },
    { header: 'useVerifyMeForTransactions', get: (r) => r.export?.useVerifyMeForTransactions },
    { header: 'cardRequestType', get: (r) => r.export?.cardRequestType },
    { header: 'ignoreSignatureForOnboarding', get: (r) => r.export?.ignoreSignatureForOnboarding },
    { header: 'usePremiumBvn', get: (r) => r.export?.usePremiumBvn },
    { header: 'useSmsWebhook', get: (r) => r.export?.useSmsWebhook },
    { header: 'isActive', get: (r) => r.export?.isActive ?? r.isActive },
    { header: 'allowArbitraryPhoneNumber', get: (r) => r.export?.allowArbitraryPhoneNumber },
    { header: 'allowIdVerificationWithMetadata', get: (r) => r.export?.allowIdVerificationWithMetadata },
    { header: 'cardStyle', get: (r) => r.export?.cardStyle },
    { header: 'typography', get: (r) => r.export?.typography },
    { header: 'cornerRadius', get: (r) => r.export?.cornerRadius },
    { header: 'language', get: (r) => r.export?.language },
    { header: 'transferGatewayEnum', get: (r) => r.export?.transferGatewayEnum },
]

function escapeCsvValue(value: unknown): string {
    if (value === null || value === undefined) return ''
    const str = typeof value === 'boolean' ? String(value) : String(value)
    if (/[",\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`
    }
    return str
}

export function buildInstitutionsCsv(items: InstitutionListItem[]): string {
    const headerRow = CSV_COLUMNS.map((c) => c.header).join(',')
    const rows = items.map((item) =>
        CSV_COLUMNS.map((c) => escapeCsvValue(c.get(item))).join(',')
    )
    return [headerRow, ...rows].join('\n')
}

export function downloadCsv(filename: string, csvContent: string) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const objectUrl = URL.createObjectURL(blob)
    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
}